import {
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAIL,
  ADD_PRODUCT,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAIL,
  FETCH_PROMOTION,
  FETCH_PROMOTION_SUCCESS,
  FETCH_PROMOTION_FAIL,
  FETCH_PROMOTIONS,
  FETCH_PROMOTIONS_SUCCESS,
  UPDATE_PROMOTION,
  UPDATE_PROMOTION_SUCCESS,
  UPDATE_PROMOTION_FAIL,
  DELETE_PROMOTION,
  DELETE_PROMOTION_SUCCESS,
  DELETE_PROMOTION_FAIL,
  FETCH_HIGHLIGHT_PRODUCTS,
  FETCH_HIGHLIGHT_PRODUCTS_SUCCESS,
  FETCH_HIGHLIGHT_PRODUCT,
  FETCH_HIGHLIGHT_PRODUCT_SUCCESS,
  FETCH_HIGHLIGHT_PRODUCT_FAIL,
  SET_HIGHLIGHT_PRODUCT,
  GET_HIGHLIGHT_PRODUCT_IMAGE_SUCCESS,
  FETCH_PRODUCT,
  FETCH_PRODUCT_SUCCESS,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
} from "../actions/Product";

const INITIAL_STATE = {
  products: {},
  isProductLoading: false,
  productUpdateError: "",

  promotions: {},
  isPromotionLoading: false,
  isPromotionError: false,
  promotionError: "",

  highlightProducts: {},
  sortedHighlightProducts: [],
  isHighlightLoading: false,
  isHighlightError: false,
  highlightError: "",

  highlightProductImages: {},
  highlightProduct: {},
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_PRODUCT:
      return { ...state, isProductLoading: true };
    case FETCH_PRODUCT_SUCCESS: {
      let updateProducts = state.products;
      updateProducts[action.payload.key] = action.payload.value;

      return { ...state, products: updateProducts, isProductLoading: false };
    }
    case FETCH_PRODUCTS:
      return { ...state, isProductLoading: true };
    case FETCH_PRODUCTS_SUCCESS:
      return { ...state, isProductLoading: false, products: action.payload };
    case FETCH_PRODUCTS_FAIL:
      return { ...state, isProductLoading: false };

    case ADD_PRODUCT:
      return { ...state, isProductLoading: true };
    case ADD_PRODUCT_SUCCESS:
    case ADD_PRODUCT_FAIL:
      return { ...state, isProductLoading: false };

    case UPDATE_PRODUCT:
      return { ...state, isProductLoading: true, productUpdateError: "" };
    case UPDATE_PRODUCT_SUCCESS:
      return { ...state, isProductLoading: false, productUpdateError: "" };
    case UPDATE_PRODUCT_FAIL:
      return {
        ...state,
        isProductLoading: false,
        productUpdateError: action.payload,
      };

    case FETCH_PROMOTIONS:
      return { ...state, isPromotionLoading: true, isPromotionError: false };
    case FETCH_PROMOTION:
      return { ...state, isPromotionLoading: true, isPromotionError: false };
    case FETCH_PROMOTIONS_SUCCESS:
      return {
        ...state,
        promotions: action.payload,
        isPromotionLoading: false,
        isPromotionError: false,
      };
    case FETCH_PROMOTION_SUCCESS:
      const promotions = state.promotions;
      const updatePromotions = {
        ...promotions,
        [action.payload.id]: action.payload.promotion,
      };
      return {
        ...state,
        isPromotionLoading: false,
        promotions: updatePromotions,
        isPromotionError: false,
      };
    case FETCH_PROMOTION_FAIL:
      return {
        ...state,
        isPromotionLoading: false,
        isPromotionError: true,
        promotionError: action.payload,
      };
    case UPDATE_PROMOTION:
      return { ...state, isPromotionLoading: true };
    case UPDATE_PROMOTION_SUCCESS:
      return { ...state, isPromotionLoading: false, isPromotionError: false };
    case UPDATE_PROMOTION_FAIL:
      return {
        ...state,
        isPromotionLoading: false,
        isPromotionError: true,
        promotionError: action.payload,
      };

    case FETCH_HIGHLIGHT_PRODUCTS:
      return { ...state, isHighlightLoading: true };
    case FETCH_HIGHLIGHT_PRODUCTS_SUCCESS:
      return {
        ...state,
        isHighlightLoading: false,
        highlightProducts: action.payload,
        sortedHighlightProducts: action.sortedPayload,
      };
    case FETCH_HIGHLIGHT_PRODUCT:
      return { ...state, isHighlightLoading: true };
    case FETCH_HIGHLIGHT_PRODUCT_SUCCESS:
      const highlights = state.highlightProducts;
      const updateHighlights = {
        ...highlights,
        [action.payload.id]: action.payload.highlightProduct,
      };
      return {
        ...state,
        isHighlightLoading: false,
        highlightProducts: updateHighlights,
      };
    case GET_HIGHLIGHT_PRODUCT_IMAGE_SUCCESS:
      const highlightImages = state.highlightProductImages;
      const updateHighlightImages = {
        ...highlightImages,
        [action.payload.id]: action.payload.url,
      };

      console.log(updateHighlightImages);

      return { ...state, highlightProductImages: updateHighlightImages };
    case SET_HIGHLIGHT_PRODUCT:
      return { ...state, highlightProduct: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ProductReducer.js